import "./ClientFooter.css";

function ClientFooter() {
  return (
    <div className="footer">
      <div className="footer-inner">
        <div className="info">
          <p className="copyright">
            {/* Tri kỷ - Công Thành Chiến 2005 */}
            Trang tài khoản
          </p>
        </div>
      </div>
    </div>
  );
}

export default ClientFooter;
